module.exports = __webpack_public_path__ + "static/media/blinds-raised.9cdd5569.svg";